import React from 'react'
import { confirmable, createConfirmation } from 'react-confirm'

import { Dialog, DialogActions, DialogTitle, Button } from '@mui/material'

const ConfirmDialog = ({ show, proceed, message }) => {
  const isDarkTheme = document.body.dataset.theme === 'dark'

  return (
    <Dialog
      open={show}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      slotProps={{
        paper: {
          sx: isDarkTheme
            ? { backgroundColor: '#1E1E1E', color: '#f4f4f6' }
            : undefined
        }
      }}
    >
      <DialogTitle id="alert-dialog-title">
        Confirmation required
      </DialogTitle>

      <div className='p-5'>
        {message}
      </div>

      <DialogActions>
        <div className="flex flex-row justify-between w-full p-5">
          <Button onClick={() => proceed(true)} variant='outlined'>Yes</Button>
          <Button onClick={() => proceed(false)} variant='contained'>No</Button>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export const confirm = createConfirmation(confirmable(ConfirmDialog))
